import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';


const select = 'select=id, createdDateTime,displayName, description, mailNickname, mail';


export class GroupsOfficeService {
  static async getGroups(gTag: any) {
    let filter = `filter=(startswith(displayName,'${gTag.toLowerCase()}'))`
    return api.get(getURL(`/groups?&$${filter}&$${select}`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async addGroup(group: any) {
    return api.post(getURL(`/groups`), group)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateGroup(id: any, fields: any) {
    return api.patch(getURL(`/groups/${id}`), fields)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async deleteGroup(id: any) {
    return api.delete(getURL(`/groups/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getMemberInGroup(id: any) {
    return api.get(getURL(`/groups/${id}/members`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async addMember(groupId: any, memberId: any){
    return api.post(getURL(`/groups/${groupId}/members/$ref`),memberId)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async removeMember(groupId: any, memberId: any){
    return api.delete(getURL(`/groups/${groupId}/members/${memberId}/$ref`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async addMultipleMember(groupId: any, membersId: any){
    return api.patch(getURL(`/groups/${groupId}`),membersId)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

}
